import axios from "axios";
import Cookies from "js-cookie";
import { IUser, ISubscription } from "../devdata/constants/interfaces.tsx";
import { FormInstance } from "antd";
import { stocks } from "../devdata/maps/chartred.js";
import {
  TradeEntry,
  TimeFilter,
  DateRange,
  TradeStats,
  TradingRules,
  BehaviorEntry,
  BehaviorCorrelation,
  BehaviorRecommendation,
} from "../types/tradingJournal";
var apilink: string;

if (process.env.REACT_APP_NODE_ENV === "prod") {
  apilink = process.env.REACT_APP_API_URL_PROD;
} else {
  apilink = process.env.REACT_APP_API_URL;
}

// Helper to get Authorization header
const getAuthHeaders = () => {
  const token = Cookies.get("token"); // Assuming Cookies is imported and used
  if (!token) {
    // console.warn("No token found for API request"); // Or throw error / redirect
    return {};
  }
  return { Authorization: `Bearer ${token}` };
};

export const handleLogin = async (
  email: string,
  password: string,
  setIsLoading: (val: boolean) => void,
  setuserToken: (val: string) => void,
  setlogin: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  // console.log("Login attempt:", email, password);

  // 1️⃣ **Check if fields are empty**
  if (!email || !password) {
    seterror(true);
    setErrorMessage("h_Fields are empty");
    console.error("Fields are empty");
    return; // ✅ Stop execution
  }

  // 2️⃣ **Validate email or phone format**
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation
  const phoneRegex = /^[0-9]{10}$/; // 10-digit phone number validation (customize if needed)

  if (!emailRegex.test(email) && !phoneRegex.test(email)) {
    seterror(true);
    setErrorMessage("h_Invalid email or phone number format");
    console.log("Invalid email or phone number format");
    return; // ✅ Stop execution
  }

  setIsLoading(true);

  try {
    const response = await axios.post(
      `${apilink}/users/login`,
      {
        username: email, // 🔹 Now correctly handles both email and phone
        password,
      },
      {
        withCredentials: true,
      }
    );

    if (response.status === 200) {
      const token = response.data.token;
      Cookies.set("token", token);
      seterror(false);
      setErrorMessage(
        "l_Login Successful. Redirecting... (Reload if not redirected)"
      );
      setuserToken(token);
      setlogin(true);
    } else {
      console.log("Login error:", response.data.message);
      setErrorMessage(response.data.message);
      seterror(true);
      setlogin(false);
    }
  } catch (error: any) {
    console.error("Login error:", error);

    if (error?.code === "ECONNABORTED") {
      setErrorMessage("h_Login error: Request Timeout (Please try again)");
    } else if (error?.response?.status === 401) {
      setErrorMessage("h_Login error: Invalid Credentials");
    } else {
      setErrorMessage(`h_Login error: ${error.message || "Unexpected error"}`);
    }

    setlogin(false);
    seterror(true);
  } finally {
    setIsLoading(false);
  }
};

export const getDhanProfile = async (
  tokenId: string,
  setPassword: (val: string) => void,
  setConfirmPassword: (val: string) => void,
  setUsername: (val: string) => void,
  setG: (val: boolean) => void,
  seterror: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  setIsLoading: (val: boolean) => void
) => {
  // console.log("Login attempt:", email, password);
  setIsLoading(true);
  try {
    const response = await axios.post(
      `${apilink}/dhan/consume`,
      {
        tokenID: tokenId,
      },
      {
        withCredentials: true,
      }
    );
    if (response.status === 200) {
      const name = response.data.name;
      const pass = response.data.password;
      setUsername(name);
      setPassword(pass);
      setConfirmPassword(pass);
      setG(true);
      sessionStorage.setItem("tokenId", tokenId);
    } else {
      console.log("Login error:", response.data.message);
      setErrorMessage(response.data.message);
      seterror(true);
    }
  } catch (error: any) {
    console.error("Login error:", error);

    if (error?.code === "ECONNABORTED") {
      setErrorMessage("h_Login error: Request Timeout (Please try again)");
    } else if (error?.response?.status === 401) {
      setErrorMessage("h_Login error: Invalid Credentials");
    } else {
      setErrorMessage(`h_Login error: ${error.message || "Unexpected error"}`);
    }

    seterror(true);
  } finally {
    setIsLoading(false);
  }
};

export const checkToken = async (
  userToken: string,
  setloading: (val: boolean) => void,
  setuserToken: (val: string) => void,
  setlogin: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  try {
    setloading(true);
    const response = await axios.get(`${apilink}/users/isloggedin`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    });
    let isLoggedInFlag = response.data.loading;

    if (isLoggedInFlag === true) {
      // console.log("Logged status:", isLoggedInFlag);
      setlogin(true);
      if (
        response.data.verify === true &&
        window.location.pathname === "/login"
      ) {
        window.location.href = "/Dashboard";
      }
    } else {
      if (response.data.err === "Expired Token") {
        setlogin(false);
        setuserToken("Expired");
        seterror(true);
        Cookies.remove("token");
        setErrorMessage("h_Token Expired Please Login Again");
      } else {
        setlogin(false);
        setuserToken("Expired");
        seterror(true);
        Cookies.remove("token");
        setErrorMessage(`h_${response.data.err}`);
      }
    }
  } catch (error: any) {
    setlogin(false);

    if (axios.isAxiosError(error) && error.code === "ECONNABORTED") {
      console.error(
        "Error: Request timed out. Please check your internet connection."
      );
      seterror(true);
      setErrorMessage(
        "Error: Request timed out. Please check your internet connection."
      );
    } else if (error.message.includes("429")) {
      seterror(true);
      setErrorMessage("h_Error: Request timed out. Rate Limit Exceded");
      console.error("Error: Request timed out. Rate Limit Exceded");
    } else {
      seterror(true);
      setErrorMessage("h_Error retrieving token");
      console.error("Error retrieving token:", error);
    }
  } finally {
    setloading(false);
  }
};
export const handleLogout = async (
  setloading: (val: boolean) => void,
  userToken: string,
  setuserToken: (val: string) => void,
  setlogin: (val: boolean) => void,
  router: any,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  try {
    setloading(true);
    const response = await axios.get(`${apilink}/users/logout`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    });
    if (!!response) {
      // console.log(response.data.status);
      Cookies.remove("token");
      seterror(true);
      setErrorMessage("l_Loging You Out");
      setuserToken("loggedout");
      setlogin(false);
    }
  } catch (error) {
    seterror(true);
    setErrorMessage("h_Error Loging Out");
    console.error("Login error:", error);
  } finally {
    setloading(false);
    setlogin(false);
    router.replace("/login");
  }
};
export const handleSignup = async (
  name: string,
  email: string,
  phone: number,
  password: string,
  confPassword: string,
  refc: string,
  photo: any,
  g: boolean,
  d: boolean,
  countryCode: string,
  address: Object,
  gender: string,
  birthdate: string,
  pan: string,
  setIsLoading: (val: boolean) => void,
  setuserToken: (val: string) => void,
  setlogin: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  try {
    setIsLoading(true);

    // 1. Form validation:
    if (!name || !email || !phone || !password || !confPassword) {
      seterror(true);
      setErrorMessage("h_Fields are empty");
      console.error("Fields are empty");
      return;
    }

    // 1.1 Validate email format:
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      seterror(true);
      setErrorMessage("h_Invalid email format");
      console.log("Invalid email format");
      return;
    }

    // 1.2 Validate password strength:
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(password) && !g && !d) {
      seterror(true);
      setErrorMessage("h_Password does not meet requirements");
      console.log("Password does not meet requirements");
      return;
    }

    // 1.3 Validate password confirmation:
    if (confPassword !== password) {
      seterror(true);
      setErrorMessage("h_Passwords do not match");
      console.log("Passwords do not match");
      return;
    }

    let refcc;
    // 2. Call API for signup:
    if (refc === "") {
      refcc = undefined;
    } else {
      refcc = refc;
    }

    const userData = {
      name: name || undefined,
      username: email || undefined,
      phone: phone || undefined,
      password: password || undefined,
      passwordConfirm: confPassword || undefined,
      gender: gender || undefined,
      birthdate: birthdate || undefined,
      pan: pan || undefined,
      photo,
      googleuser: g,
      dhanuser: d,
      countrycode: countryCode,
      referralCode: refcc,
    };
    const response = await axios.post(`${apilink}/users/signup`, userData, {
      validateStatus: () => true,
    });

    // Handle signup response:
    if (response.status === 200) {
      // console.log("Signup successful!");
      const token = response.data.token;
      Cookies.set("token", token);
      setuserToken(token);
      seterror(true);
      setErrorMessage(
        "l_Signup Successful Please Check Your Email for verification (Your Email is your username) (Refresh if you don't get redirected)"
      );
      window.location.href = "/verify";
    } else {
      seterror(true);
      setErrorMessage(`h_Signup failed: ${response.data.message}`);
    }
  } catch (error) {
    seterror(true);
    setErrorMessage("h_Error during signup");
    console.log("Unexpected error during signup:", error.message);
  } finally {
    setIsLoading(false);
  }
};
export const handleverify = async (
  setloading: (val: boolean) => void,
  userToken: string,
  otp: string,
  user: IUser,
  router: any,
  updateState: (val: IUser) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void,
  setlogin: (val: boolean) => void
) => {
  try {
    setloading(true);
    const response = await axios.post(
      `${apilink}/users/verify`,
      {
        otp,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    );
    if (response.status === 201) {
      // console.log(response.data.status);
      user.isverified = true;
      setlogin(true);
      updateState(user);
      seterror(true);
      setErrorMessage("l_Verified!");
      setTimeout(() => {
        router.replace("/Dashboard");
      }, 2000);
    }
  } catch (error) {
    seterror(true);
    setErrorMessage("h_Invalid OTP or verification expired.");
    console.error("Verifying error:", error);
  } finally {
    setloading(false);
  }
};
export const handleresend = async (
  setloading: (val: boolean) => void,
  userToken: string,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  try {
    setloading(true);
    const response = await axios.get(
      `${apilink}/users/resendotp`,

      {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    );
    if (!!response) {
      // console.log(response.data.status);

      seterror(true);
      setErrorMessage("l_Otp sent to registered email!");
    }
  } catch (error) {
    seterror(true);
    setErrorMessage("h_Error resend");
    console.error("Resend error:", error);
  } finally {
    setloading(false);
  }
};
export const cacheuserdata = async (
  userToken: string,
  setloading: (val: boolean) => void,
  setlogin: (val: boolean) => void,
  updateState: (val: IUser) => void,
  setsub: (val: ISubscription) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void,
  setdaystocks: (val: [string]) => void,
  setIsDhanLogged: (val: boolean) => void
) => {
  setloading(true);
  try {
    const r1 = await axios.get(`${apilink}/all`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    });
    if (r1.status === 227) {
      setError(true);
      Cookies.remove("token");
      setErrorMessage(`h_${response.data.err}`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
    updateState(r1.data.userdata.user);
    setIsDhanLogged(r1.data.userdata.user.dhanuser);
    setdaystocks(r1.data.userdata.user.watchlist);
    const sub = {
      type: r1.data.userdata.user.subscription,
      subon: r1.data.userdata.user.subon,
      subexp: r1.data.userdata.user.subexp,
      issubexp: r1.data.userdata.user.issubexp,
    };
    setsub(sub);

    setlogin(true);
  } catch (e) {
    setlogin(false);
    seterror(true);
    setErrorMessage("h_Error Caching User Data");
    console.log("Error Caching User Data", e);
    window.location.href = "/login";
  } finally {
    setloading(false);
  }
};

export const forgetpassword = async (
  email: string,
  setIsLoading: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  if (!email) {
    setErrorMessage("h_Fields are empty");
    seterror(true);
    console.error("Fields are empty");
    return;
  }

  // 1.1 Validate email format:
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation
  if (!emailRegex.test(email)) {
    seterror(true);
    setErrorMessage("h_Invalid email format");
    console.log("Invalid email format");
  }

  setIsLoading(true);
  try {
    const response = await axios.post(
      `${apilink}/users/forgot`,
      {
        username: email,
      },
      {
        withCredentials: true,
      }
    );

    if (response.status === 200) {
      const token = response.data.updatetoken;
      seterror(true);
      setErrorMessage(`l_${response.data.message}.`);
    } else {
      console.log("Error Reseting your password", response.data.message);
      setErrorMessage("h_Error Reseting your password");
      seterror(true);
    }
  } catch (error) {
    console.log("Error Reseting your password", error);
    setErrorMessage("h_Error Reseting your password");
    seterror(true);
  } finally {
    setIsLoading(false);
  }
};

export const resetpassword = async (
  token: string,
  password: string,
  confPassword: string,
  setIsLoading: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  setIsLoading(true);
  try {
    const response = await axios.patch(
      `${apilink}/users/reset`,
      {
        newPassword: password,
        newPasswordConfirm: confPassword,
        token,
      },
      {
        withCredentials: true,
      }
    );

    if (response.status === 200) {
      setErrorMessage("l_Password Reset Successful.");
      seterror(true);
      window.location.replace("/login");
    } else {
      console.log("Reset Error", response.data.message);
      setErrorMessage("h_Error Reseting Your Password.");
      seterror(true);
    }
  } catch (error) {
    if (error.response.status === 401) {
      setErrorMessage(`h_Invalid token or token expired.`);
      seterror(true);
    } else {
      setErrorMessage(`h_Reset Error:${error}`);
      seterror(true);
    }
    console.error("Reset Error:", error);
  } finally {
    setIsLoading(false);
  }
};

export const subscribeUser = async (
  userToken: string,
  subtype: "Yearly" | "Monthly",
  setLoading: (val: boolean) => void,
  setorder: (val: any) => void,
  setErrorMessage: (val: string) => void,
  setError: (val: boolean) => void
) => {
  try {
    setLoading(true);
    const response = await axios.post(
      `${apilink}/sub/create-order`,
      { subtype },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    );
    if (response.status === 200) {
      setorder(response.data.order);
    } else if (response.status === 227) {
      setError(true);
      Cookies.remove("token");
      setErrorMessage(`h_${response.data.err}`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      setErrorMessage("h_Error Sending Payment Request");
      setError(true);
      console.error("Subscription failed:", response.data.message);
    }
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.code === "ECONNABORTED") {
      console.error("Error: Request timed out. Please check your connection.");
      setErrorMessage(
        "h_Error: Request timed out. Please check your connection."
      );
    } else {
      console.error("Error during subscription:", error.message);
      setErrorMessage("h_Error during subscription");
    }
    setError(true);
  } finally {
    setLoading(false);
  }
};

export const unsubscribeUser = async (
  userToken: string,
  setLoading: (val: boolean) => void,
  setsub: (val: ISubscription) => void,
  setErrorMessage: (val: string) => void,
  setError: (val: boolean) => void
) => {
  console.log("Access Denied");
};

export const handleUpdateDetails = async (
  userToken: string,
  data: FormInstance,
  updateState: (val: IUser) => void,
  setLoading: (val: boolean) => void,
  setmodal: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  setError: (val: boolean) => void
) => {
  try {
    const updatedData = await data.validateFields();
    setLoading(true);

    const response = await axios.patch(
      `${apilink}/users/updateMe`,
      updatedData,
      {
        headers: { Authorization: `Bearer ${userToken}` },
      }
    );

    if (response.status === 200) {
      // console.log("Details updated successfully:", response.data);
      updateState(response.data.data.user);

      setErrorMessage("l_Updated details successfully.");
      setError(true);
    } else if (response.status === 227) {
      setError(true);
      Cookies.remove("token");
      setErrorMessage(`h_${response.data.err}`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      setError(true);
      setErrorMessage("h_Failed to update details.");
    }
  } catch (error) {
    console.error("Error updating details:", error);
    setError(true);
    setErrorMessage("h_Error updating details.");
  } finally {
    setLoading(false);
    setmodal(false);
  }
};
export const handleUpdatewatch = async (
  userToken: string,
  watchlist: [string],
  updateState: (val: IUser) => void,
  setLoading: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  setError: (val: boolean) => void
) => {
  try {
    setLoading(true);

    const response = await axios.patch(
      `${apilink}/users/updatemywatch`,
      { watchlist },
      {
        headers: { Authorization: `Bearer ${userToken}` },
      }
    );

    if (response.status === 200) {
      // console.log("Details updated successfully:", response.data);
      updateState(response.data.data.user);
    } else if (response.status === 227) {
      setError(true);
      Cookies.remove("token");
      setErrorMessage(`h_${response.data.err}`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      setError(true);
      setErrorMessage("h_Failed to update details.");
    }
  } catch (error) {
    console.error("Error updating details:", error);
    setError(true);
    setErrorMessage("h_Error updating details.");
  } finally {
    setLoading(false);
  }
};
export const getdata = async (
  userToken: string,
  setLoading: (val: boolean) => void,
  setlive: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  setError: (val: boolean) => void
) => {
  setLoading(true);
  try {
    const response = await axios.get(`${apilink}/prescans`, {
      headers: { Authorization: `Bearer ${userToken}` },
    });
    // console.log(response.status);

    if (response.status === 200 || response.status === 304) {
      // console.log("Details updated successfully:", response.data);
      // updateState(response.data.data.user);

      sessionStorage.setItem("lsm", JSON.stringify(response.data.data?.lsm));
      sessionStorage.setItem(
        "oidata",
        JSON.stringify(response.data.data?.oidata)
      );
      sessionStorage.setItem("index", JSON.stringify(response.data.data.index));
      // Parse the "allc" data from response
      let allc = response.data.data.allc;

      let updatedData = allc
        .map((stock) => {
          const match = stocks.find((dat) => dat.name === stock.name);
          return match
            ? {
              ...stock,
              sector: match.sector,
              pil: Math.max(stock.pibear, stock.pibull), // Use Math.max for clarity
            }
            : stock;
        })
        .filter((stock) => stock.volume > 0);
      const sortedSectors = response.data.data.index
        .sort((a, b) => b.per_chg - a.per_chg) // Sort by per_chg in descending order
        .map((sector) => sector.name); // Extract only the sector names
      const unsortedSectors = response.data.data.index
        .sort((b, a) => b.per_chg - a.per_chg) // Sort by per_chg in descending order
        .map((sector) => sector.name); // Extract only the sector names

      const topSectors = new Set(sortedSectors.slice(0, 2)); // Top 2 bull
      const nextSectors = new Set(sortedSectors.slice(2, 4)); // Next 2
      const topunsortedSectors = new Set(unsortedSectors.slice(0, 2)); // Top 2 bear
      const nextunsortedSectors = new Set(unsortedSectors.slice(2, 4)); // Next 2

      updatedData = updatedData.map((stock) => {
        let pilMultiplier = 1; // Default multiplier
        let bb = 0;

        if (stock.pibear > stock.pibull) {
          // Bear market logic
          bb = 1;
          if (topunsortedSectors.has(stock.sector)) {
            pilMultiplier = 1.5;
          } else if (nextunsortedSectors.has(stock.sector)) {
            pilMultiplier = 1.2;
          }
        } else {
          if (stock.pibear < stock.pibull) {
            // Bull market logic
            bb = 2;
            if (topSectors.has(stock.sector)) {
              pilMultiplier = 1.5;
            } else if (nextSectors.has(stock.sector)) {
              pilMultiplier = 1.2;
            }
          }
        }

        let newScore = 0.7;
        let isVWAPInvalid = false;
        let trendLabel = "Trend Broken";
        let trendBadge = 0; // 0 = Broken, 1 = Weak, 2 = Strong

        // Bearish
        if (bb === 1) {
          const isBelowEMA9 = !stock.piema9;
          const isBelowEMA20 = !stock.piema20;
          const isBelowVWAP = !stock.pivwap;

          const isAboveVWAP = stock.pivwap;

          // Scoring logic
          if (isBelowEMA9 && isBelowEMA20 && isBelowVWAP) {
            newScore = 1.0;
          } else if (isBelowEMA20 && isBelowVWAP) {
            newScore = 0.85;
          } else {
            newScore = 0.7;
          }

          if (isAboveVWAP) isVWAPInvalid = true;

          // Trend label
          if (isBelowEMA20 && isBelowVWAP) {
            trendLabel = "Strong Trend";
            trendBadge = 2;
          } else if (!isBelowEMA20 && isBelowVWAP) {
            trendLabel = "Pullback";
            trendBadge = 1;
          } else if (!isBelowVWAP) {
            trendLabel = "Trend Broken";
            trendBadge = 0;
          }
        }

        // Bullish
        if (bb === 2) {
          const isAboveEMA9 = stock.piema9;
          const isAboveEMA20 = stock.piema20;
          const isAboveVWAP = stock.pivwap;

          const isBelowVWAP = !isAboveVWAP;

          // Scoring logic
          if (isAboveEMA9 && isAboveEMA20 && isAboveVWAP) {
            newScore = 1.0;
          } else if (!isAboveEMA9 && isAboveEMA20 && isAboveVWAP) {
            newScore = 0.85;
          } else {
            newScore = 0.7;
          }

          if (isBelowVWAP) isVWAPInvalid = true;

          // Trend label
          if (isAboveEMA20 && isAboveVWAP) {
            trendLabel = "Strong Trend";
            trendBadge = 2;
          } else if (!isAboveEMA20 && isAboveVWAP) {
            trendLabel = "Pullback";
            trendBadge = 1;
          } else if (isBelowVWAP) {
            trendLabel = "Trend Broken";
            trendBadge = 0;
          }
        }


        const finalScore = stock.pil * pilMultiplier * newScore;

        let piStatus = 0; // 0 = Ignore, 1 = Watchlist, 2 = Good to Enter
        if (!isVWAPInvalid && typeof finalScore === "number") {
          if (finalScore >= 14) piStatus = 2;
          else if (finalScore >= 10) piStatus = 1;
        }

        return {
          ...stock,
          pil: finalScore,
          pibull: bb === 2 ? finalScore : stock.pibull,
          pibear: bb === 1 ? finalScore : stock.pibear,
          pistatus: piStatus,
          trendLabel,
          trendBadge,
        };
      });

      sessionStorage.setItem("all", JSON.stringify(updatedData));

      // Initialize empty arrays for each scan category
      // let pdhStocks = [];
      // let pdlStocks = [];
      // let pmswvStocks = [];
      // let nmswvStocks = [];
      // let pmswv10Stocks = [];
      // let nmswv10Stocks = [];
      // let p2dlStocks = [];
      // let p2dhStocks = [];
      let pibearStocks = [];
      let pibullStocks = [];
      // let pivwapStocks = [];
      // let piema9Stocks = [];
      // let piema20Stocks = [];
      // Iterate over "allc" and categorize stocks
      updatedData.forEach((stock) => {
        // if (stock.pdh) pdhStocks.push(stock);
        // if (stock.pdl) pdlStocks.push(stock);
        // if (stock.pmswv) pmswvStocks.push(stock);
        // if (stock.nmswv) nmswvStocks.push(stock);
        // if (stock.pmswv10) pmswv10Stocks.push(stock);
        // if (stock.nmswv10) nmswv10Stocks.push(stock);
        // if (stock.p2dl) p2dlStocks.push(stock);
        // if (stock.p2dh) p2dhStocks.push(stock);
        if (stock.pibear) pibearStocks.push(stock);
        if (stock.pibull) pibullStocks.push(stock);
        // if (stock.pivwap) pivwapStocks.push(stock);
        // if (stock.piema9) piema9Stocks.push(stock);
        // if (stock.piema20) piema20Stocks.push(stock);
      });

      // Store each filtered list in sessionStorage
      // sessionStorage.setItem("pdh", JSON.stringify(pdhStocks));
      // sessionStorage.setItem("pdl", JSON.stringify(pdlStocks));
      // sessionStorage.setItem("pmswv", JSON.stringify(pmswvStocks));
      // sessionStorage.setItem("nmswv", JSON.stringify(nmswvStocks));
      // sessionStorage.setItem("pmswv10", JSON.stringify(pmswv10Stocks));
      // sessionStorage.setItem("nmswv10", JSON.stringify(nmswv10Stocks));
      // sessionStorage.setItem("p2dl", JSON.stringify(p2dlStocks));
      // sessionStorage.setItem("p2dh", JSON.stringify(p2dhStocks));
      sessionStorage.setItem("pibear", JSON.stringify(pibearStocks));
      sessionStorage.setItem("pibull", JSON.stringify(pibullStocks));
      // sessionStorage.setItem("pivwap", JSON.stringify(pivwapStocks));
      // sessionStorage.setItem("piema20", JSON.stringify(piema20Stocks));
      // sessionStorage.setItem("piema9", JSON.stringify(piema9Stocks));
    } else if (response.status === 227) {
      setError(true);
      Cookies.remove("token");
      setErrorMessage(`h_${response.data.err}`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      setError(true);
      setlive(false);
      setErrorMessage("h_Failed to update details.");
    }
  } catch (error) {
    console.error("Error updating details:", error, error.message);
    setlive(false);
    setError(true);
    setErrorMessage("h_Data Unavailable");
  } finally {
    setLoading(false);
  }
};

// --- TradeEntry API Client Functions ---
export const addTradeEntry = async (
  entry: Omit<TradeEntry, "id" | "_id" | "createdAt" | "updatedAt" | "userId">
): Promise<TradeEntry> => {
  const response = await axios.post(`${apilink}/journal/trades`, entry, {
    headers: getAuthHeaders(),
  });
  return response.data.data.tradeEntry; // Mongoose uses _id, map to id if your frontend expects 'id'
};

export const loadTradeEntries = async (
  timeFilter: TimeFilter = "all",
  customDateRange?: DateRange
): Promise<TradeEntry[]> => {
  const params: any = { timeFilter };
  if (customDateRange && timeFilter === "custom") {
    params.customDateRange = JSON.stringify(customDateRange);
  }
  const response = await axios.get(`${apilink}/journal/trades`, {
    headers: getAuthHeaders(),
    params,
  });
  return response.data.data.tradeEntries.map((entry) => ({
    ...entry,
    id: entry._id,
  }));
};

export const updateTradeEntry = async (
  id: string,
  updatedEntry: Partial<Omit<TradeEntry, "id" | "_id" | "userId">>
): Promise<TradeEntry | null> => {
  try {
    const response = await axios.put(
      `${apilink}/journal/trades/${id}`,
      updatedEntry,
      { headers: getAuthHeaders() }
    );
    return {
      ...response.data.data.tradeEntry,
      id: response.data.data.tradeEntry._id,
    };
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404)
      return null;
    throw error;
  }
};

export const deleteTradeEntry = async (id: string): Promise<boolean> => {
  try {
    await axios.delete(`${apilink}/journal/trades/${id}`, {
      headers: getAuthHeaders(),
    });
    return true;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404)
      return false;
    // console.error("Error deleting trade entry:", error); // Keep for debugging
    return false; // Or throw error to be handled by caller
  }
};

// --- TradingRules API Client Functions ---
export const addTradingRule = async (
  rule: Omit<TradingRules, "id" | "_id" | "userId">
): Promise<TradingRules> => {
  const response = await axios.post(`${apilink}/journal/rules`, rule, {
    headers: getAuthHeaders(),
  });
  return {
    ...response.data.data.tradingRule,
    id: response.data.data.tradingRule._id,
  };
};

export const loadTradingRules = async (): Promise<TradingRules[]> => {
  const response = await axios.get(`${apilink}/journal/rules`, {
    headers: getAuthHeaders(),
  });
  return response.data.data.tradingRules.map((rule) => ({
    ...rule,
    id: rule._id,
  }));
};

export const updateTradingRule = async (
  id: string,
  updatedRule: Partial<Omit<TradingRules, "id" | "_id" | "userId">>
): Promise<TradingRules | null> => {
  try {
    const response = await axios.put(
      `${apilink}/journal/rules/${id}`,
      updatedRule,
      { headers: getAuthHeaders() }
    );
    return {
      ...response.data.data.tradingRule,
      id: response.data.data.tradingRule._id,
    };
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404)
      return null;
    throw error;
  }
};

export const deleteTradingRule = async (id: string): Promise<boolean> => {
  try {
    await axios.delete(`${apilink}/journal/rules/${id}`, {
      headers: getAuthHeaders(),
    });
    return true;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404)
      return false;
    return false;
  }
};

// --- BehaviorEntry API Client Functions ---
export const addBehaviorEntry = async (
  entry: Omit<
    BehaviorEntry,
    "id" | "_id" | "createdAt" | "updatedAt" | "userId"
  >
): Promise<BehaviorEntry> => {
  // Ensure date is in ISO string format for backend consistency if not already
  const payload = { ...entry, date: new Date(entry.date).toISOString() };
  const response = await axios.post(`${apilink}/journal/behaviors`, payload, {
    headers: getAuthHeaders(),
  });
  return {
    ...response.data.data.behaviorEntry,
    id: response.data.data.behaviorEntry._id,
  };
};

export const loadBehaviorEntries = async (
  timeFilter: TimeFilter = "all",
  customDateRange?: DateRange
): Promise<BehaviorEntry[]> => {
  const params: any = { timeFilter };
  if (customDateRange && timeFilter === "custom") {
    params.customDateRange = JSON.stringify(customDateRange);
  }
  const response = await axios.get(`${apilink}/journal/behaviors`, {
    headers: getAuthHeaders(),
    params,
  });
  return response.data.data.behaviorEntries.map((entry) => ({
    ...entry,
    id: entry._id,
    date: new Date(entry.date).toISOString().split("T")[0],
  })); // Ensure date is string for forms
};

export const updateBehaviorEntry = async (
  id: string,
  updatedEntry: Partial<Omit<BehaviorEntry, "id" | "_id" | "userId">>
): Promise<BehaviorEntry | null> => {
  const payload = updatedEntry.date
    ? { ...updatedEntry, date: new Date(updatedEntry.date).toISOString() }
    : updatedEntry;
  try {
    const response = await axios.put(
      `${apilink}/journal/behaviors/${id}`,
      payload,
      { headers: getAuthHeaders() }
    );
    return {
      ...response.data.data.behaviorEntry,
      id: response.data.data.behaviorEntry._id,
    };
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404)
      return null;
    throw error;
  }
};

export const deleteBehaviorEntry = async (id: string): Promise<boolean> => {
  try {
    await axios.delete(`${apilink}/journal/behaviors/${id}`, {
      headers: getAuthHeaders(),
    });
    return true;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404)
      return false;
    return false;
  }
};

// --- Statistics and Analysis API Client Functions ---
export const getTradeStats = async (
  timeFilter: TimeFilter = "all",
  customDateRange?: DateRange
): Promise<TradeStats> => {
  const params: any = { timeFilter };
  if (customDateRange && timeFilter === "custom") {
    params.customDateRange = JSON.stringify(customDateRange);
  }
  const response = await axios.get(`${apilink}/journal/trades/stats`, {
    headers: getAuthHeaders(),
    params,
  });
  return response.data.data.stats;
};

export const getBehaviorCorrelations = async (
  timeFilter: TimeFilter = "all",
  customDateRange?: DateRange
): Promise<BehaviorCorrelation[]> => {
  const params: any = { timeFilter };
  if (customDateRange && timeFilter === "custom") {
    params.customDateRange = JSON.stringify(customDateRange);
  }
  const response = await axios.get(
    `${apilink}/journal/behaviors/correlations`,
    { headers: getAuthHeaders(), params }
  );
  return response.data.data.correlations;
};

export const getBehaviorRecommendations = async (
  timeFilter: TimeFilter = "all",
  customDateRange?: DateRange
): Promise<BehaviorRecommendation[]> => {
  const params: any = { timeFilter };
  if (customDateRange && timeFilter === "custom") {
    params.customDateRange = JSON.stringify(customDateRange);
  }
  const response = await axios.get(
    `${apilink}/journal/behaviors/recommendations`,
    { headers: getAuthHeaders(), params }
  );
  return response.data.data.recommendations;
};

// --- Export API Client Functions ---
export const exportTradeEntriesCsv = async (
  timeFilter: TimeFilter = "all",
  customDateRange?: DateRange
): Promise<string> => {
  // Returns CSV string or triggers download
  const params: any = { timeFilter };
  if (customDateRange && timeFilter === "custom") {
    params.customDateRange = JSON.stringify(customDateRange);
  }
  const response = await axios.get(`${apilink}/journal/trades/export/csv`, {
    headers: getAuthHeaders(),
    params,
    responseType: "blob", // Important for file downloads
  });
  // Create a Blob from the response
  const blob = new Blob([response.data], { type: "text/csv" });
  // Create a link element, hide it, set the URL and filename, then click it
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  const contentDisposition = response.headers["content-disposition"];
  let fileName = `trading-journal-trades-${timeFilter}.csv`;
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/i);
    if (fileNameMatch && fileNameMatch.length === 2)
      fileName = fileNameMatch[1];
  }
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(link.href);
  return "Export initiated."; // Or handle differently
};

export const exportBehaviorEntriesCsv = async (
  timeFilter: TimeFilter = "all",
  customDateRange?: DateRange
): Promise<string> => {
  const params: any = { timeFilter };
  if (customDateRange && timeFilter === "custom") {
    params.customDateRange = JSON.stringify(customDateRange);
  }
  const response = await axios.get(`${apilink}/journal/behaviors/export/csv`, {
    headers: getAuthHeaders(),
    params,
    responseType: "blob",
  });
  const blob = new Blob([response.data], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  const contentDisposition = response.headers["content-disposition"];
  let fileName = `trading-journal-behavior-${timeFilter}.csv`;
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/i);
    if (fileNameMatch && fileNameMatch.length === 2)
      fileName = fileNameMatch[1];
  }
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(link.href);
  return "Export initiated.";
};

export const getConsent = async (
  setloading: (val: boolean) => void,
  setErrorMessage: (val: string) => void,
  seterror: (val: boolean) => void
) => {
  try {
    setloading(true);
    const response = await axios.get(`${apilink}/dhan/consent`);
    if (!!response) {
      return response.data.consentID;
    }
  } catch (error) {
    seterror(true);
    setErrorMessage("h_Error Getting Consent ID");
    console.error("Login error:", error);
  } finally {
    setloading(false);
  }
};
